export const authQueryKeys = {
  user: ["getUser"] as const,
};
